import { FunctionComponent, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { HomeIcon } from '../Icons';
import { BreadcrumbItem } from './types';
import { BreadcrumbListItem } from './BreadcrumbListItem';

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

const BreadcrumbsComp: FunctionComponent<BreadcrumbProps> = ({ items, className }) => (
  <nav className={twMerge('flex items-center gap-1', items.length > 0 && 'border-b border-quaternary-200 pb-4', className)}>
    <HomeIcon className='m-1 size-5 text-gray-400' />
    {items.map((item) => (
      <BreadcrumbListItem key={item.label} item={item} />
    ))}
  </nav>
);

export const Breadcrumbs = memo(BreadcrumbsComp);
